import React, { useContext, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Context } from "../Store";
import styles from "./PlayerPage.module.scss";
import ActionReplays from "./ActionReplays";
import { openLightbox, updateLightbox, handleHover, updatePreview } from "../utils/storyUIHandlers";
import Games from "./Games";
import LeaderboardPrev from "./LeaderboardPrev";
import NextVisit from "./NextVisit";

const PlayerPage = () => {
  const [state] = useContext(Context);
  const { guid, id } = useParams();
  const history = useHistory();

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  // Destructure with fallbacks to avoid crashes
  const { parsedPlayers = [], actionReplays = [], games = [], guid: storyGuid = "" } = state;

  const playerId = parseInt(id, 10);
  const player = parsedPlayers.find((p) => p.id === playerId);

  // Redirect if data isn't ready or player not found
  useEffect(() => {
    if (!player || parsedPlayers.length === 0) {
      history.replace(`/${guid}`);
    }
  }, [parsedPlayers, player, history, guid]);

  // Early return if data is still loading or invalid
  if (!player) return null;

  const playerPhoto = player.photo ? `data:image/jpeg;base64, ${player.photo}` : player.gender === "male" ? "./img/boy.png" : "./img/girl.png";
  const playerActionReplays = actionReplays.filter((replay) => replay.players?.includes(player.id));
  const playerGames = games.filter((game) => game.players?.includes(player.id));

  const ViewFullStoryButton = () => (
    <section className={`${styles.playerIntro} section`}>
      <button className={styles.button} onClick={() => history.push(`/${storyGuid}`)}>
        View the full story
      </button>
    </section>
  );

  return (
    <>
      <main>
        <section className={`${styles.playerContainer} section section--padded-story`}>
          <div className={styles.playerImage}>
            <div className={styles.playerImageSizer}>
              <img src={playerPhoto} alt={player.name} />
            </div>
          </div>
          <h1>{player.name}</h1>
        </section>

        {playerActionReplays.length === 0 && playerGames.length === 0 ? (
          <>
            <section className={`${styles.playerIntro} section`}>
              <p>We don’t have any replays or achievements starring you! Why not check out the group media on the main story to see where you are.</p>
              <ViewFullStoryButton />
            </section>
            <LeaderboardPrev />
          </>
        ) : (
          <>
            <section className={`${styles.playerIntro} section`}>
              <p>This is your unique story from your Flight Club visit. It contains all your action replays and game events.</p>
            </section>
            <LeaderboardPrev />
            {playerActionReplays.length > 0 && <ActionReplays key={player.id} videos={playerActionReplays} handleHover={handleHover} openLightbox={openLightbox} />}
            {playerGames.length > 0 && <Games games={playerGames} players={parsedPlayers} handleHover={handleHover} openLightbox={openLightbox} />}
            <ViewFullStoryButton />
          </>
        )}
        <NextVisit />
      </main>
    </>
  );
};

export default PlayerPage;
